import * as React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CheckboxVisibility,
  DefaultButton,
  DetailsList,
  IColumn,
  IDetailsRowProps,
  Selection,
  Modal,
  PrimaryButton,
  SearchBox,
  SelectionMode,
} from '@fluentui/react';
import * as Api from '../../../../api/src';
import ModalHeader from '../../../../control/modalHeader';
import { ToastAppMsgContext } from '../../../../context/toastApp.Context';
import { ToastAppType } from '../../../../common/constant/enum/toastAppType';
import { NoDataFound } from '../../../../control/noDataFound';
import { _renderRow } from '../../../../control/function/detailList';

export interface ModaComponentProps {
  IsOpen: boolean;
  onCloseModal: () => void;
  onSaveClick?: () => void;
  Item?: number | null;
}
const VendorsApi = new Api.VendorsApi();
const ModalAddUsersToVendor = ({ onSaveClick, Item, IsOpen, onCloseModal }: ModaComponentProps) => {
  const [isShow, SetIsShow] = React.useState(false);
  const { setToastData } = React.useContext(ToastAppMsgContext);
  const { t } = useTranslation();
  const getTitle = (): string => {
    return t('AddUsersToVendor');
  };
  const [userList, setUserList] = React.useState<Api.UserDto[]>([]);
  const [search, setSearch] = React.useState<string>('');
  const [userSelected, setUserSelected] = React.useState<number[]>([]);

  const _columns = [
    {
      key: 'Name',
      name: t('VendorName'),
      maxWidth: 350,
      fieldName: 'FullName',
      className: 'flex-center',
    },
    {
      key: 'Email',
      name: t('Email'),
      maxWidth: 350,
      fieldName: 'Email',
      className: 'flex-center',
    }
  ] as IColumn[];

  React.useEffect(() => {
    SetIsShow(IsOpen);
    if (IsOpen) {
      getData();
    }
  }, [IsOpen]);

  const getData = async () => {
    let data = await VendorsApi.apiVendorsGetUsersNotAddIdGet(Item || 0, search);
    if(data.data.length)
    {
      setUserList(data.data);
    }
  }

  const onClose = () => {
    onCloseModal();
    SetIsShow(false);
  };

  const onSave = async () => {
    let userVendorModel = {
      VendorId: Item,
      UserIds: userSelected
    } as Api.UserVendorModel
    var data = await VendorsApi.apiVendorsAddUsersPost(userVendorModel);
    if (!data || data.status !== 200) return;
    setToastData({ Message: t('Successed'), Type: ToastAppType.Success });
    SetIsShow(false);
    if (onSaveClick) {
      onSaveClick();
    }
  };

  const selection = new Selection({
    onSelectionChanged: () => {
      const selectedItems = selection.getSelection() as Api.UserDto[];
      let data = selectedItems.map(x => x.Id || 0);
      setUserSelected(data);
    },
  });

  return (
    <Modal isOpen={isShow} isModeless={true}>
      <ModalHeader
        title={getTitle()}
        onCloseModal={() => {
          onClose();
        }}
      />
      <div className={'modal-content'} style={{ width: 700}}>
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col padding-left-0 margin-right-auto ms-md2" style={{ minWidth: 250 }}>
              <SearchBox
                placeholder={t('Search')}
                onChange={ async (e, newValue) => {
                  setSearch(newValue ?? '');
                }}
                onSearch={ async () => {
                  await getData();
                }}
              />
            </div>
          </div>
          <div className="ms-Grid-row">
          <div className="ms-md12  ms-Grid-col padding-left-0 padding-right-0">
            {(userList?.length || 0) > 0 && (
              <DetailsList
                items={userList}
                columns={_columns}
                checkboxVisibility={CheckboxVisibility.always}
                selectionMode={SelectionMode.multiple}
                selection={selection}
                onShouldVirtualize={() => false}
                onRenderRow={(props) => {
                  return _renderRow(props || ({} as IDetailsRowProps), () => {
                  });
                }}
                className="custom-details-list"
              />
            )}
            <NoDataFound isShow={(userList?.length ?? 0) === 0}></NoDataFound>
          </div>
          </div>
        </div>
      </div>
      <div className={'modal-footer'}>
        <DefaultButton
          onClick={() => {
            onClose();
          }}
          className={'margin-left-10'}
        >
          {t('Close')}
        </DefaultButton>
        <PrimaryButton
          className={'margin-left-10'}
          onClick={() => {
            onSave();
          }}
        >
          {t('Save')}
        </PrimaryButton>
      </div>
    </Modal>
  );
};
export default ModalAddUsersToVendor;
